import React, { Component, Fragment } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { withWrapper } from "create-react-server/wrapper";
import { bindActionCreators } from "redux";
import specials from "modules/specials";
import events from "modules/events";
import articles from "modules/articles";

import "./style.css";

import EventCard from "./EventCard";
import AfishaCard from "./AfishaCard";
import AfishaBanner from "./AfishaBanner";
import AfishaSearchEvents from "./AfishaSearchEvents";
import AfishaSelections from "./AfishaSelections";
import RangeSlider from "./RangeSlider";
import AfishaSearchInfo from "./AfishaSearchInfo";
import LoadMore from "./LoadMore";
import AfishaMap from "./AfishaMap";
// import AfishaInfoPartners from "./AfishaInfoPartners";
// import AfishaMagazinePartners from "./AfishaMagazinePartners";
// import AfishaGeneralPartners from "./AfishaGeneralPartners";

class Events extends Component {
  constructor(props) {
    super(props);

    const specialsEvent = this.props.match.params.id || 3;

    props.getArticles(specialsEvent);
    props.getSpecials(specialsEvent);

    props.getSpecialsTypes(specialsEvent);
    props.getSpecialsDates(specialsEvent);
    props.getSpecialsOptions(specialsEvent);

    props.getEvents(specialsEvent);

    this.state = {
      numberInterval: [],
      timeInterval: [],
      changedInterval: "",
      timeArray: [],
      dateArray: "",
      date: "",
      clientWidth: typeof window !== "undefined" && window.innerWidth < 700,
      hideSelection: typeof window !== "undefined" && window.innerWidth < 700,
      bannerWidth: typeof window !== "undefined" && window.innerWidth < 700,
      entered: false,
      query: "",
      requests: [],
      clearRange: false,
      isPartnerSelected: false,
      isSpecialOffersSelected: false,
      eventsArray: null,
      prevArray: null,
      visible: 10,
      arrayLength: 0,
      isBalloonSelected: false,
      balloonId: null,
      libraries: null
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.state.entered && nextState.query !== this.state.qyery) {
      this.setState({ entered: false });
    }

    if (nextProps.reset) {
      this.setState(state => ({
        requests: "",
        date: this.props.dates,
        // timeInterval: this.props.times,
        query: ""
        // clearRange: true
      }));

      this.state.isPartnerSelected && this.onPartnerBtnClick();
      this.state.isSpecialOffersSelected && this.onSpecialOffersBtnClick();
      this.onScrollToTop();
    }

    if (this.props.events !== nextProps.events) {
      this.state.isBalloonSelected && this.resetMapEventsData();
      this.getFilteredArray(nextProps.events);
    }

    if (!this.props.changeView.list && nextProps.changeView.list) {
      this.resetMapEventsData();
    }
  }

  onScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  getInitialInterval = props => {
    let min, max, interval;

    interval = props.map(keys => this.regExrNumberValue(keys));
    min = Math.min(...interval);
    max = Math.max(...interval);

    this.setState({ timeInterval: props });

    this.getNumberInterval([min, max]);
  };

  updateDimensions = () => {
    this.setState({
      clientWidth: window.innerWidth < 700,
      hideSelection: window.innerWidth < 700,
      bannerWidth: window.innerWidth < 700
    });
  };

  getDateArray = props => {
    if (typeof props === "object") {
      let obj = Object.keys(props).map(key =>
        props[key].text.replace(/,.*/g, "")
      );

      this.setState({
        dateArray: obj,
        date: obj
      });
    }

    if (typeof props === "string") {
      this.setState(state => ({
        date: props === "Все дни" ? state.dateArray : [props]
      }));
    }
  };

  getTimeArray = props => {
    Object.keys(props).map(key => this.state.timeArray.push(props[key]));

    this.getInterval();
  };

  getInterval = () => {
    let min, max, interval;

    interval = this.state.timeArray.map(keys => this.regExrNumberValue(keys));
    min = Math.min(...interval);
    max = Math.max(...interval);

    this.getNumberInterval([min, max]);
  };

  getNumberInterval = value => {
    let numb1 = `${value[0]}`.includes(".")
      ? Math.ceil(value[0]) * 2 - 1
      : Math.ceil(value[0]) * 2;
    let numb2 = `${value[1]}`.includes(".")
      ? Math.floor(value[1]) * 2 + 1
      : Math.floor(value[1]) * 2;

    this.setState({
      numberInterval: [numb1, numb2]
    });
  };

  getRangeValue = value => {
    this.setState(state => ({
      clearRange: state.clearRange ? !state.clearRange : state.clearRange,
      timeInterval: [
        this.formatRangeValue(value[0]),
        this.formatRangeValue(value[1])
      ]
    }));
  };

  onAfterChangeInterval = value => {
    this.setState({
      changedInterval: [
        this.formatRangeValue(value[0]),
        this.formatRangeValue(value[1])
      ]
    });
  };

  formatRangeValue = value => {
    let numb = this.regExrRangeValue(value);
    let numb2, numb1;
    if (numb <= 1 || numb >= 47) {
      return numb === 1 ? `${this.props.times[0]}` : `${this.props.times[1]}`;
    } else {
      if (numb % 2 === 0) {
        numb2 = `${numb > 2 ? Math.ceil(numb - numb / 2) : numb / 2}:00`;
        return numb2;
      } else {
        numb1 = `${numb !== 1 ? Math.floor(numb - numb / 2) : 0}:30`;
        return numb1;
      }
    }
  };

  regExrNumberValue = value => {
    return `${value}`.replace(/:/g, ".");
  };

  regExrRangeValue = value => {
    let numb = `${value}`.replace(/\..*/g, "");
    return !isNaN(numb) ? Number(numb) : numb;
  };

  onHideSelection = () => {
    this.setState(state => ({
      hideSelection: !state.hideSelection
    }));
  };

  onInputChange = e => {
    this.setState({
      query: e.target.value
    });
  };

  onEnterKeyPress = e => {
    if (e.key === "Enter" || e.keyCode === 13) {
      this.setState({
        entered: true
      });
    }
  };

  onSearchBtnClick = () => {
    this.setState({
      entered: true
    });
  };

  getSelectedButtons = text => {
    // const req = this.state.requests;
    let not_found = true;
    let arr = [];

    if (text === "") {
      arr = [];
    } else {
      // if (req.length !== 0) {
      //   for (let i = 0; i < req.length; i++) {
      //     if (req[i] === text) {
      //       not_found = false;
      //     } else {
      //       arr.push(req[i]);
      //     }
      //   }
      // }

      if (not_found) {
        arr.push(text);
      }
    }

    this.setState({
      requests: arr
    });
  };

  onPartnerBtnClick = () => {
    this.setState(
      state => ({
        isPartnerSelected: !state.isPartnerSelected
      }),
      () =>
        this.state.isBalloonSelected
          ? this.resetMapEventsData()
          : this.getFilteredArray(this.props.events)
    );
  };

  onSpecialOffersBtnClick = () => {
    this.setState(
      state => ({
        isSpecialOffersSelected: !state.isSpecialOffersSelected
      }),
      () =>
        this.state.isBalloonSelected
          ? this.resetMapEventsData()
          : this.getFilteredArray(this.props.events)
    );
  };

  getFilteredArray = events => {
    const { isPartnerSelected, isSpecialOffersSelected } = this.state;
    let spec, part, array;

    events.forEach(pos => {
      if (pos.event_type === "partner" && pos.type !== "Спецпредложение") {
        return Object.defineProperty(pos.features, "style", {
          value: "#FF0000",
          enumerable: false,
          configurable: true
        });
      } else if (pos.type === "Спецпредложение") {
        return Object.defineProperty(pos.features, "style", {
          value: "#FFCC00",
          enumerable: false,
          configurable: true
        });
      }
    });

    if (isPartnerSelected) {
      if (!isSpecialOffersSelected) {
        part = events.filter(
          item =>
            item.event_type === "partner" && item.type !== "Спецпредложение"
        );
      } else {
        part = events.filter(item => item.event_type === "partner");
      }

      array = part;
    } else if (isSpecialOffersSelected) {
      spec = events.filter(item => item.type === "Спецпредложение");

      array = spec;
    } else if (isPartnerSelected && isSpecialOffersSelected) {
      array = Object.assign(spec, part);
    } else {
      array = events;
    }

    const librariesArray = array
      .map(item => item["features"])
      .filter(
        (s1, pos, arr) =>
          arr.findIndex(s2 => s2.id === s1.id && s2.id !== 0) === pos
      );

    this.setState(state => ({
      eventsArray: state.eventsArray === array ? state.eventsArray : array,
      prevArray: state.prevArray === array ? state.prevArray : array,
      libraries:
        state.libraries !== librariesArray ? librariesArray : state.libraries,
      arrayLength: Number(array.length),
      visible: 10
    }));
  };

  renderBalloonEventCards = id => {
    this.setState(state => ({
      eventsArray: state.prevArray.filter(key => id === key["features"]["id"]),
      balloonId: id,
      isBalloonSelected: true
    }));
  };

  resetMapEventsData = () => {
    this.setState(state => ({
      balloonId: null,
      isBalloonSelected: false
    }));

    this.props.resetSpecials();
    this.getFilteredArray(this.props.events);
  };

  loadMoreResults = () => {
    this.setState(state => ({
      visible: state.visible + 10
    }));
  };

  render() {
    const {
      numberInterval,
      timeInterval,
      changedInterval,
      date,
      clientWidth,
      bannerWidth,
      hideSelection,
      query,
      entered,
      requests,
      clearRange,
      isPartnerSelected,
      isSpecialOffersSelected,
      eventsArray,
      visible,
      arrayLength,
      isBalloonSelected,
      balloonId,
      libraries
    } = this.state;

    const {
      events,
      specials,
      articles,
      // total_items,
      // total_pages,
      // current_page,
      changeView
    } = this.props;

    return (
      <Fragment>
        <Helmet>
          <title>События</title>
        </Helmet>
        {specials ? (
          <div className="container">
            <section className="header-banner">
              <AfishaBanner item={specials} />
            </section>
            {articles && (
              <section className="afisha-events content">
                {articles.map((item, i) => (
                  <AfishaCard key={i} item={item} />
                ))}
              </section>
            )}
            <section className="afisha-search">
              <div className="afisha-search__container content">
                {events && (
                  <AfishaSearchEvents
                    query={query}
                    clientWidth={clientWidth}
                    onInputChange={this.onInputChange}
                    onEnterKeyPress={this.onEnterKeyPress}
                    onSearchBtnClick={this.onSearchBtnClick}
                  />
                )}
                {clientWidth && <Placeholder />}
                {clientWidth && (
                  <HideSelection
                    hideSelection={hideSelection}
                    onHideSelection={this.onHideSelection}
                  />
                )}
                {!hideSelection && (
                  <AfishaSelections
                    query={query}
                    entered={entered}
                    clientWidth={clientWidth}
                    timeInterval={timeInterval}
                    getDateArray={this.getDateArray}
                    changedInterval={changedInterval}
                    isPartnerSelected={isPartnerSelected}
                    onPartnerBtnClick={this.onPartnerBtnClick}
                    getSelectedButtons={this.getSelectedButtons}
                    isSpecialOffersSelected={isSpecialOffersSelected}
                    onSpecialOffersBtnClick={this.onSpecialOffersBtnClick}
                  />
                )}
                {!hideSelection ? (
                  numberInterval.length ? (
                    <RangeSlider
                      clearRange={clearRange}
                      timeInterval={timeInterval}
                      numberInterval={numberInterval}
                      getRangeValue={this.getRangeValue}
                      onAfterChangeInterval={this.onAfterChangeInterval}
                    />
                  ) : (
                    this.props.times &&
                    this.getInitialInterval(this.props.times)
                  )
                ) : (
                  ""
                )}
              </div>
            </section>
            <div style={{ width: "100%" }}>
              {changeView.map && (
                <div className="afisha-map content">
                  <AfishaMap
                    balloonId={balloonId}
                    libraries={libraries}
                    isBalloonSelected={isBalloonSelected}
                    renderBalloonEventCards={this.renderBalloonEventCards}
                  />
                </div>
              )}
              {eventsArray
                ? (changeView.list ||
                    (changeView.map && isBalloonSelected)) && (
                    <section
                      className="afisha-search_results-container content"
                      style={
                        changeView.map ? { gridTemplateColumns: "1fr" } : null
                      }
                    >
                      <div className="afisha-search_results-container__cards">
                        {Object.keys(eventsArray.slice(0, visible)).map(
                          (item, i) => (
                            <EventCard
                              key={i}
                              item={eventsArray[item]}
                              clientWidth={clientWidth}
                              isViewMap={changeView.map}
                              resetMapEventsData={this.resetMapEventsData}
                            />
                          )
                        )}
                      </div>
                      {changeView.list && (
                        <AfishaSearchInfo
                          dates={date}
                          query={query}
                          requests={requests}
                          total_items={arrayLength}
                          timeInterval={timeInterval}
                          onScrollToTop={this.onScrollToTop}
                          isPartnerSelected={isPartnerSelected}
                          isSpecialOffersSelected={isSpecialOffersSelected}
                        />
                      )}
                    </section>
                  )
                : null}
            </div>
            {changeView.list ? (
              <section className="afisha-search_more-results content">
                {/* {total_pages === 0 || total_pages === current_page ? null : (
                <LoadMore eventId={this.props.match.params.id} />
                )} */}
                {visible <= arrayLength && (
                  <LoadMore loadMoreResults={this.loadMoreResults} />
                )}
              </section>
            ) : null}
            {/* {changeView.map && <AfishaGeneralPartners />} */}
            {/* {changeView.list && (
              <React.Fragment>
                <AfishaInfoPartners />
                <AfishaMagazinePartners />
              </React.Fragment>
            )} */}
            {/*<React.Fragment>*/}
            {/*  <AfishaInfoPartners />*/}
            {/*  <AfishaMagazinePartners />*/}
            {/*</React.Fragment>*/}
          </div>
        ) : (
          <PageNull />
        )}
      </Fragment>
    );
  }
}

const PageNull = () => {
  return (
    <div
      style={{
        height: "calc(100vh - 255px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: "0 20px"
      }}
    >
      Данное событие не существует или недоступно в данный момент
    </div>
  );
};

const HideSelection = ({ onHideSelection, hideSelection }) => {
  return (
    <button
      onClick={() => onHideSelection()}
      style={{
        border: "2px solid rgba(186, 186, 194, 0.5)",
        boxSizing: "border-box",
        borderRadius: "5px",
        width: "100%",
        height: "30px",
        fontSize: "14px",
        color: "#2B2B2B"
      }}
    >
      {!hideSelection ? "Скрыть фильтры" : "Показать фильтры"}
    </button>
  );
};

const Placeholder = () => {
  return (
    <p
      style={{
        fontSize: "13px",
        color: "#808080",
        marginBottom: "20px"
      }}
    >
      Введите название мероприятия, библиотеку, станцию метро или район
    </p>
  );
};

const mapStateToProps = state => ({
  specials: state.specials.specials,
  times: state.specials.times,
  dates: state.specials.dates,
  reset: state.specials.reset,
  changeView: state.specials.view,

  events: state.events.events,
  total_items: state.events.total_items,
  current_page: state.events.pagination.current_page,
  total_pages: state.events.pagination.total_pages,
  pages: state.events.pages,
  str: state.events.str,

  articles: state.articles.articles
});

const mapDispatchToProps = dispatch => ({
  getSpecials: bindActionCreators(specials.actions.getSpecials, dispatch),
  getEvents: bindActionCreators(events.actions.getEvents, dispatch),
  getArticles: bindActionCreators(articles.actions.getArticles, dispatch),
  getSpecialsTypes: bindActionCreators(
    specials.actions.getSpecialsTypes,
    dispatch
  ),
  getSpecialsDates: bindActionCreators(
    specials.actions.getSpecialsDates,
    dispatch
  ),
  getSpecialsOptions: bindActionCreators(
    specials.actions.getSpecialsOptions,
    dispatch
  ),
  resetSpecials: bindActionCreators(specials.actions.resetSpecials, dispatch)
});

export default withWrapper(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Events)
);



// WEBPACK FOOTER //
// ./src/components/Events/index.js